// extracted by mini-css-extract-plugin
module.exports = {"container":"Slider_container__3wb8z","valueContainer":"Slider_valueContainer__2jR6F","sufix":"Slider_sufix__eQ-PN","input":"Slider_input__3aJGH"};